/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AnalyticsResultFormatterMessage } from "../../../messages/analytics-result-formatter.message";

export const triggerSalesValue = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as AnalyticsResultFormatterMessage;
  const template = message?.template?.layout[0]?.colProps;
  const found = template?.find((o: any) => o.key === "salesValue");
  if (found?.compProps) {
    found.compProps.value = message?.raw?.salesValue?.total?.formatted;
  }
  if (found?.compProps) {
    if (message?.raw?.salesValue?.day?.labels) {
      found.compProps.salesValue.day.labels =
        message?.raw?.salesValue?.day?.labels;
    }
    if (message?.raw?.salesValue?.week?.labels) {
      found.compProps.salesValue.week.labels =
        message?.raw?.salesValue?.week?.labels;
    }
    if (message?.raw?.salesValue?.month?.labels) {
      found.compProps.salesValue.month.labels =
        message?.raw?.salesValue?.month?.labels;
    }
    if (message?.raw?.salesValue?.year?.labels) {
      found.compProps.salesValue.year.labels =
        message?.raw?.salesValue?.year?.labels;
    }
    if (message?.raw?.salesValue?.day?.chartSeries) {
      for (const obj of found.compProps.salesValue.day?.chartSeries) {
        const _found = message?.raw?.salesValue?.day?.chartSeries?.find(
          (o: any) => o.name === obj?.name
        );
        if (_found?.data) {
          obj.data = _found?.data?.map((d: number) => Math.round(d));
        }
      }
    }
    if (message?.raw?.salesValue?.week?.chartSeries) {
      for (const obj of found.compProps.salesValue.week?.chartSeries) {
        const _found = message?.raw?.salesValue?.week?.chartSeries?.find(
          (o: any) =>
            o.name?.trim()?.toLowerCase() === obj?.name?.trim()?.toLowerCase()
        );
        if (_found?.data) {
          obj.data = _found?.data?.map((d: number) => Math.round(d));
        }
      }
    }
    if (message?.raw?.salesValue?.month?.chartSeries) {
      for (const obj of found.compProps.salesValue.month?.chartSeries) {
        const _found = message?.raw?.salesValue?.month?.chartSeries?.find(
          (o: any) =>
            o.name?.trim()?.toLowerCase() === obj?.name?.trim()?.toLowerCase()
        );
        if (_found?.data) {
          obj.data = _found?.data?.map((d: number) => Math.round(d));
        }
      }
    }
    if (message?.raw?.salesValue?.year?.chartSeries) {
      for (const obj of found.compProps.salesValue.year?.chartSeries) {
        const _found = message?.raw?.salesValue?.year?.chartSeries?.find(
          (o: any) =>
            o.name?.trim()?.toLowerCase() === obj?.name?.trim()?.toLowerCase()
        );
        if (_found?.data) {
          obj.data = _found?.data?.map((d: number) => Math.round(d));
        }
      }
    }
  }

  return true;
};
